export enum SecurityFormattingType {
  Long = 'Long',
  Short = 'Short'
}
